import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const cvusAdapter = createEntityAdapter({
  selectId: x => x.cvuId,
})

const initialState = cvusAdapter.getInitialState();

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getCvus: builder.query({
      query: () => 'cvus',
      transformResponse: responseData => {
        return cvusAdapter.setAll(initialState, responseData)
      },
      providesTags: (result, error, arg) => [
        { type: 'Cvus', id: 'LIST' }
      ]
    }),    
    addCvus: builder.mutation({
        query: (newCvus)=>({
          url: 'cvus',
          method: 'post',
          body: newCvus
        }),
        invalidatesTags: ["Cvus", "CamposCobranzaSantander", "RegistrosCobranzaSantander"]
      }),
    })
  });
  
  export const { useGetCvusQuery, useAddCvusMutation } = extendedApiSlice;
  
  //A: returns the query result object
  export const selectCvusResult = extendedApiSlice.endpoints.getCvus.select();
  
  //A: created memoized selector
  const selectCvusData = createSelector(
    selectCvusResult,
    cvusResult => cvusResult.data  //A: normalized state object with ids and entities
  );
//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllCvus,
  selectById: selectCvusById,
  selectIds: selectCvusIds
} = cvusAdapter.getSelectors(state => selectCvusData(state) ?? initialState);